var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6ccd1b84d5ebeeafd89a8d85a5cd9b0f60f759a6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["appsmith@appsmith"]={id:"6ccd1b84d5ebeeafd89a8d85a5cd9b0f60f759a6"};
      